export function getFileKey(file) {
  return `${file?.name}|${file?.size}|${file?.lastModified}`;
}

export function dedupeFiles(files = []) {
  const seen = new Set();
  return Array.from(files || []).filter((file) => {
    const key = getFileKey(file);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
